import { useState, useEffect, useRef } from 'react';
import { SendButton } from './buttons';

export const SendCountdownButton = ({ seconds = 10, label = 'Enviar', onClick }) => {
  const [countdown, setCountdown] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (countdown > 0) {
      setDisabled(true);
      timerRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            setDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timerRef.current);
  }, [countdown]);

  const handleClick = async () => {
    if (disabled) return;

    const result = await onClick?.();

    // Si el resultado tiene error_code "0005", activa el contador
    if (result?.error_code === "0005" && result?.value) {
      setCountdown(result.value);
    }
  };

  return (
    <SendButton onClick={handleClick} disabled={disabled}>
      {disabled ? `Reenviar en ${countdown}s` : label}
    </SendButton>
  );
};
